export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-zoom-in-612342d0f7cd3f1956e559c6ac8a2e16.svg";